import Heading from "components/Typography/Heading"
import React, { memo, useEffect, useMemo, useState } from "react"
import styled from "styled-components"

const HeaderContainer = styled.div`
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  height: 62px;
  display: flex;
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
  z-index: 1;
`

const HeaderContent = styled.div`
  height: 36px;
  width: 100%;
  display: flex;
  padding: 12px 16px 0px 16px;
  width: 100%;
`

const StyledImage = styled.img`
  object-fit: contain;
`

interface BannerCardHeaderProps {
  logoFile: File | undefined
  logoUrl: string
}

const BannerCardHeader: React.FC<BannerCardHeaderProps> = (props: BannerCardHeaderProps) => {
  const { logoFile, logoUrl } = props

  const [logoPreview, setLogoPreview] = useState<string>("")

  const previewUrl = useMemo(() => {
    return logoPreview || logoUrl || ""
  }, [logoPreview, logoUrl])

  const showImage = useMemo(() => {
    return !!previewUrl || !!logoUrl
  }, [logoPreview, logoUrl])

  useEffect(() => {
    let logoUrl: string | null = null

    if (logoFile) {
      logoUrl = URL.createObjectURL(logoFile)
      setLogoPreview(logoUrl)
    } else {
      setLogoPreview("")
    }

    // Clean up URL when changing file or unmounting component
    return () => {
      if (logoUrl) {
        URL.revokeObjectURL(logoUrl)
      }
    }
  }, [logoFile])

  return (
    <HeaderContainer>
      <HeaderContent>
        {showImage && <StyledImage src={previewUrl} alt="logo" />}
        {!showImage && (
          <Heading variant="h5" color="white">
            Seu logo
          </Heading>
        )}
      </HeaderContent>
    </HeaderContainer>
  )
}

export default memo(BannerCardHeader)
